import {Component, inject, Input} from '@angular/core';
import {SearchSelectorService} from '../../core/search-selector.service';
import {SelectorContainer} from '../../core/definitions/selector-container';
import {SectionsContainer} from '../../core/definitions/sections-container';
import {AConst} from '../../core/a-const.enum';

@Component({
    selector: 'app-object-new-object-view',
    templateUrl: './object-new-object-view.component.html',
    styleUrls: ['./object-new-object-view.component.scss'],
    standalone: false
})
export class ObjectNewObjectViewComponent{
  // Injections
  private readonly searchSelectorService: SearchSelectorService = inject(SearchSelectorService);

  @Input() selectorContainer: SelectorContainer;
  @Input() sectionsContainer: SectionsContainer;

  AConst = AConst;

  selectorOverlay() {
    this.searchSelectorService.disableSelector(this.selectorContainer);
  }

}
